import React from "react";
import { useApp } from "context";
import { Custom, Item } from "components";
import { Enums } from "utils";
import { Box, Grid } from "@mui/material";
import { IAppointment } from "interfaces";
import { Feedback } from "types";

type Props = {
  patientId: number | null;
  appointments: IAppointment[];
  onClick: (step: number) => void;
};

export const Appointment = (props: Props) => {
  const { service, setFeedback, t, theme } = useApp();
  const [appointment, setAppointment] = React.useState<IAppointment>();

  function handleSelect(appointment: IAppointment) {
    setAppointment(appointment);
  }

  async function handleSubmit() {
    if (appointment) {
      const [status, response] = await service.appointment.updateCheckIn(
        appointment.appointmentId,
        true,
        props.patientId as number,
        true
      );
      if (status === Enums.EnumResponse.Success) {
        setFeedback({
          message: t.message.qiosk.check_in_with_account,
          severity: Enums.EnumFeedback.Success,
        } as Feedback);
        props.onClick && props.onClick(Enums.EnumCheckInStep.Home);
      } else {
        setFeedback({
          message: t.message.feedback.request_error,
          severity: Enums.EnumFeedback.Error,
        } as Feedback);
      }
    } else {
      setFeedback({
        message: t.message.qiosk.select_one,
        severity: Enums.EnumFeedback.Info,
      } as Feedback);
    }
  }

  const handleHome = () =>
    props.onClick && props.onClick(Enums.EnumCheckInStep.Email);

  return (
    <Box
      sx={{
        width: "80%",
        display: "flex",
        alignItems: "start",
        flexDirection: "column",
      }}
    >
      <>
        <Grid container spacing={theme.margin.md}>
          <Grid item xs={12}>
            <Custom.Button
              variant="outlined"
              sx={{
                fontSize: theme.font.sm,
                marginBottom: theme.margin.xl,
              }}
              onClick={handleHome}
            >
              {t.action.return_check_in}
            </Custom.Button>
          </Grid>
          <Grid item xs={12}>
            {props.appointments &&
              props.appointments.length > 0 &&
              props.appointments.map((item: IAppointment) => {
                return (
                  <Item.Appointment
                    item={item}
                    key={item.appointmentId}
                    onSelect={() => handleSelect(item)}
                    selected={item.appointmentId === appointment?.appointmentId}
                  />
                );
              })}
          </Grid>
          <Grid
            item
            xs={12}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Custom.Button onClick={handleSubmit} size="large">
              {t.action.submit}
            </Custom.Button>
          </Grid>
        </Grid>
      </>
    </Box>
  );
};
